import { notification } from 'antd'
import { getToken, customAxios as axios } from '../../../request'
import { addCountryUrl, listCountriesUrl, listCountryUrl, updateCountryStatusUrl } from '../api/countries'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'


export const addCountry = (valData) => async (dispatch) => {
  dispatch(showPageLoad())

  let { data } = await axios.post(addCountryUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}


export const listAllCountries = (filters) => async (dispatch) => {
  let config = {
    params: { ...filters },
    headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
  }
  let { data } = await axios.get(listCountriesUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data.data

}


export const getCountry = id => async (dispatch) => {
  let config = {
    headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
  }
  let { data } = await axios.get(listCountryUrl(id), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    dispatch({ type: 'LIST_COUNTRY', payload: data })
  }
  return data.data
}


export const updateCountry = (valData, id) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.put(listCountryUrl(id), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || `Updated Successfully`
    })
  } else {
    notification.error({
      message: data.message || 'Error updating'
    })
  }
  return data
}


export const updateCountryStatusFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateCountryStatusUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
